/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
import { ToggleButton } from "@adobe/react-spectrum";
import {
  RankedTester,
  rankWith,
  RendererProps,
  uiTypeIs,
} from "@jsonforms/core";
import {
  JsonFormsDispatch,
  useJsonForms,
  withJsonFormsLayoutProps,
} from "@jsonforms/react";
import React, { useEffect, useState } from "react";

// Lodash
import { get } from "lodash";

// Redux
import { useSelector } from "react-redux";

// Utils
import { evaluateContextRule, extractPath } from "../utils/commonUtils";

export const toggleButtonRendererTester: RankedTester = rankWith(
  4,
  uiTypeIs("ToggleButton")
);

function ToggleButtonRenderer({ uischema, visible, enabled }: RendererProps) {
  const { renderers, cells } = useJsonForms();

  const content = uischema.options?.content;
  const spectrumProps = uischema.options?.spectrumProps;
  const style = uischema.options?.style;
  // const name = uischema.options?.name;
  const [isSelected, setIsSelected] = useState(uischema.options?.isSelected);

  // console.log("uischema.options?.isSelected", uischema.options?.isSelected);

  useEffect(() => {
    // Sync the state if prop is updated
    // console.log("useEffect", uischema.options?.isSelected, isSelected);
    if (isSelected !== uischema.options?.isSelected) {
      setIsSelected(uischema.options?.isSelected);
    }
  }, [uischema.options?.isSelected]);

  const context = useJsonForms();

  const toggleButtonHooks =
    context?.config?.lifecycleHooks?.onSuccessCallbacks?.toggleButton;
  const onToggle = toggleButtonHooks?.onToggle;

  const onPressHandler = () => {
    setIsSelected(!isSelected);
    onToggle(uischema.options?.name, !isSelected);
  };

  // Determine if the component should be visible and enabled
  let componentVisibility = visible;
  let componentEnabled = enabled;

  // If there is a context rule, evaluate it and use that visibility/enabled rule instead.
  if (uischema.options?.contextRule) {
    // grab the scope from the contextRule
    const scope = extractPath(uischema.options?.contextRule?.condition?.scope);
    // get the redux store state based on the scope provided
    const reduxState = useSelector((state: any) =>
      get(state?.reduxState, scope)
    );
    const contextRuleValidation = evaluateContextRule(
      uischema.options?.contextRule,
      reduxState
    );
    componentVisibility = contextRuleValidation?.visible;
    componentEnabled = contextRuleValidation?.enabled;
  }

  return (
    <ToggleButton
      data-testid="toggle-button"
      {...spectrumProps}
      UNSAFE_style={style}
      isSelected={isSelected}
      onChange={() => onPressHandler()}
      isDisabled={!componentEnabled}
      isHidden={!componentVisibility}
    >
      {typeof content === "string" ? (
        content
      ) : (
        <JsonFormsDispatch
          renderers={renderers}
          cells={cells}
          uischema={content}
          schema={{}}
        />
      )}
    </ToggleButton>
  );
}

export default withJsonFormsLayoutProps(ToggleButtonRenderer);
